import Button from "@mui/material/Button";
import { IRequest } from "../../model/types";

import styles from "./LastRequestCard.module.scss";
import { truncate } from "@src/shared/lib/truncate";
import { Tooltip } from "@mui/material";

interface LastRequestCardProps {
  request: IRequest;
  onRepeat: (request: IRequest) => void;
  iconSrc?: string;
}

const formatDate = (date: string) => {
  if (!date) return "";

  return new Date(date).toLocaleDateString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

const formatSalary = (salaryFrom?: number | null, salaryTo?: number | null) => {
  if (!salaryFrom && !salaryTo) {
    return "Не указана";
  }

  if (salaryFrom && salaryTo) {
    return `${salaryFrom.toLocaleString("ru-RU")} - ${salaryTo.toLocaleString(
      "ru-RU",
    )}`;
  }

  if (salaryFrom) {
    return `от ${salaryFrom.toLocaleString("ru-RU")}`;
  }

  return `до ${salaryTo?.toLocaleString("ru-RU")}`;
};

const getStatusVariant = (status: string) => {
  switch (status) {
    case "success":
    case "done":
    case "completed":
      return styles.statusSuccess;
    case "pending":
    case "processing":
    case "in_progress":
      return styles.statusPending;
    case "failed":
    case "error":
      return styles.statusFailed;
    default:
      return styles.statusDefault;
  }
};

export const LastRequestCard = ({
  request,
  onRepeat,
  iconSrc,
}: LastRequestCardProps) => {
  const { title_vacancy, created_at, params, status } = request;
  const displayTitle = truncate(title_vacancy, 40);
  const isTruncated = title_vacancy.length > 25;

  const tags = params?.key_skills?.slice(0, 4) || [];

  return (
    <article className={styles.card}>
      <div className={styles.leftBlock}>
        <div className={styles.iconWrapper}>
          {iconSrc ? (
            <img src={iconSrc} alt="Иконка вакансии" className={styles.icon} />
          ) : (
            <div className={styles.iconFallback} />
          )}
        </div>

        <div className={styles.vacancyBlock}>

          {isTruncated ? (
            <Tooltip title={title_vacancy} arrow>
              <h3 className={styles.title}>{displayTitle}</h3>
            </Tooltip>
          ) : (
            <h3 className={styles.title}>{displayTitle}</h3>
          )}

          {!!tags.length && (
            <div className={styles.tags}>
              {tags.map((tag) => (
                <span key={tag} className={styles.tag}>
                  {tag}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className={styles.infoColumn}>
        <span className={styles.infoLabel}>Статус</span>
        <span className={`${styles.statusDot} ${getStatusVariant(status)}`} />
      </div>

      <div className={styles.infoColumn}>
        <span className={styles.infoLabel}>Дата</span>
        <span className={styles.infoValue}>{formatDate(created_at)}</span>
      </div>

      <div className={styles.infoColumn}>
        <span className={styles.infoLabel}>Зарплата</span>
        <span className={styles.salaryValue}>
          {formatSalary(params?.salary_from, params?.salary_to)}
        </span>
      </div>

      <div className={styles.actionsBlock}>
        <Button
          variant="contained"
          className={styles.repeatButton}
          onClick={() => onRepeat(request)}
        >
          Повторить запрос
        </Button>
      </div>
    </article>
  );
};
